"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var getPathnameFromFilePath_exports = {};
__export(getPathnameFromFilePath_exports, {
  getPathnameFromFilePath: () => getPathnameFromFilePath
});
module.exports = __toCommonJS(getPathnameFromFilePath_exports);
function getPathnameFromFilePath(inputPath) {
  var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, strict = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
  var path = inputPath.replace(/\+(spa|ssg|ssr|api)\.tsx?$/, "");
  var lastSlash = path.lastIndexOf("/");
  var file = path.slice(lastSlash + 1);
  var fileName = options.preserveExtensions ? file : file.replace(/\.[a-z]+$/, "");
  function paramsError(part) {
    throw new Error(`[one] Params doesn't fit route:

      - path: ${path}
      - part: ${part}
      - fileName: ${fileName}
      - params:

${JSON.stringify(params, null, 2)}`);
  }
  var dirname = (lastSlash === -1 ? "." : path.slice(0, lastSlash) || "/").split("/").map(function(segment) {
    return segment.replace(/\+(api|ssg|ssr|spa)$/, "");
  }).join("/").replace(/\([^/]+\)/gi, "").replace(/\[([^\]]+)\]/g, function(_, paramName) {
    var value = params[paramName];
    if (value != null) return String(value);
    if (strict) throw paramsError(paramName);
    return ":" + paramName;
  });
  var nameWithParams = (function() {
    if (fileName === "index" && !options.includeIndex) {
      return "/";
    }
    if (fileName.startsWith("[...")) {
      var part = fileName.replace("[...", "").replace("]", "");
      if (!params[part]) {
        if (strict) {
          throw paramsError(part);
        }
        return `/*`;
      }
      return `/${params[part]}`;
    }
    return `/${fileName.split("/").map(function(part2) {
      if (part2[0] === "[") {
        var found = params[part2.slice(1, part2.length - 1)];
        if (!found) {
          if (strict) {
            throw paramsError(part2);
          }
          return ":" + part2.replace("[", "").replace("]", "");
        }
        return found;
      }
      return part2;
    }).join("/")}`;
  })();
  return `${dirname}${nameWithParams}`.replace(/\/\/+/gi, "/");
}
//# sourceMappingURL=getPathnameFromFilePath.js.map
